import { isMiniProgramOrWebview, getPlatformType, isTitansAppOrWebview } from "@nibfe/mkt-env-api";
import { PlatformType } from "@nibfe/mkt-env-api/src/libs/enum";
import { convertH5ToWebviewPath, convertLinkToAppMiddleOpenLink } from "@nibfe/mkt-navigate-api";
import { useEngineContext } from "./useEngineContext";
import { useMonitorNavigation } from "./useMonitorNavigation";
export function useMonitorJumper() {
    const ctx = useEngineContext();
    const { monitorNavigateTo } = useMonitorNavigation();
    const isInMini = isMiniProgramOrWebview();
    const isInApp = isTitansAppOrWebview();
    /**
     * 在当前环境打开H5
     */
    function monitorNavigateToH5(url) {
        if (!isH5URL(url)) {
            ctx._raptorReport.reportLog(`${url}跳转错误`, new Error('非H5链接使用monitorNavigateToH5'), {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
            return monitorNavigateTo({
                url,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        if (isInMini) {
            const platform = getPlatformType();
            const webviewUrl = platform === PlatformType.mtMinaWebview
                // 对美团小程序有特殊逻辑，使用酒小的WebView打开
                ? isH5URL(url) ? `/hotel/pages/h5/index?q=${encodeURIComponent(url)}` : url : convertH5ToWebviewPath(url, platform);
            return monitorNavigateTo({
                url: webviewUrl,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        else if (isInApp) {
            return monitorNavigateTo({
                url,
                _meituan: {
                    enableElinkLog: true
                }
            });
        }
        else {
            return monitorNavigateTo({
                url: convertLinkToAppMiddleOpenLink(url)
            });
        }
    }
    /**
     * 跳转至美团App
     */
    function monitorNavigateToMeituan(url) {
        if (isInMini) {
            ctx._raptorReport.reportLog('小程序内使用monitorNavigateToMeituan', new Error(`${url}跳转错误`), {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
            return monitorNavigateToH5(url);
        }
        else if (isInApp) {
            return monitorNavigateTo({
                url,
                _meituan: {
                    enableElinkLog: true
                }
            });
        }
        else {
            const envokeLink = convertLinkToAppMiddleOpenLink(url);
            return monitorNavigateTo({
                url: envokeLink
            });
        }
    }
    function monitorNavigateToSmart(url) {
        if (isH5URL(url)) {
            return monitorNavigateToH5(url);
        }
        else if (isMeituanURL(url)) {
            return monitorNavigateToMeituan(url);
        }
        else {
            ctx._raptorReport.reportLog('monitorNavigateToSmart无法判断', new Error(`${url}跳转错误`), {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
            return monitorNavigateTo({
                url,
                _web: {
                    miniProgramNative: true
                }
            });
        }
    }
    return {
        monitorNavigateToH5,
        monitorNavigateToMeituan,
        monitorNavigateToSmart
    };
}
/**
 * 判断给定的 URL 是否为 H5 页面的 URL
 * @see https://sky.sankuai.com/docs/nibfe/platform-common-api-repository/
 */
export const isH5URL = (url) => {
    return Boolean(url && url.indexOf('http') === 0);
};
/**
 * 判断给定的 URL 是否为 imeituan
 */
export const isMeituanURL = (url) => {
    return Boolean(url && url.startsWith('imeituan://'));
};
